import React, { useEffect } from 'react';
import Config from '../../config/Config';
import Loader from '../../utils/Loader';
import LoadingPaymentModel from '../common/loadingPaymentModel';
import $ from 'jquery';
import { connect } from 'react-redux';
import { validateUser } from '../../redux/sso/sso.actions';
import { setPayMethod } from '../../redux/buyCourse/buyCourse.actions';
import ErrorModal from '../common/errorModal';
import { getParameterByName } from '../../utils/commonFunctions';
import { setEnableProctor } from '../../redux/userAuthentication/userAuth.actions';
const Sso = ({
	errorPanel: { panelClass, panelMsg },
	referer,
	validateUser,
	setPayMethod,
	setEnableProctor,
}) => {
	useEffect(() => {
		const srcReqSystem = getParameterByName('srcReqSystem') ? getParameterByName('srcReqSystem') : Config.LTAPIURL
		Config.updateLTAPIURL(srcReqSystem)
		Loader.hide();
		$('#chat-circle').hide();
		validateUser();
		setPayMethod(getParameterByName('payment_type'));
		localStorage.setItem('payment_type', getParameterByName('payment_type'));
		localStorage.setItem('srcReqSystem', srcReqSystem)
		if (referer === 'landing') {
			$('.body-container').css('background', '#e5f3fa');
			$('.download-app').hide();
		} else if (referer.toLowerCase() === 'uap' && getParameterByName('is_proctor').toLowerCase() === 'true') {
			setEnableProctor(true);
		}
		return () => {
			$('#chat-circle').show();
		};
	}, [validateUser, referer, setPayMethod, setEnableProctor]);

	return (
		<div id="wrapper">
			<ErrorModal />
			{referer === 'landing' ? (
				<div style={{ 'margin-top': '100px' }}>
					<LoadingPaymentModel />
				</div>
			) : (
				<div className="col-lg-12 col-md-12 col-sm-12 login-pg-container">
					<div className="col-lg-12 col-md-12 col-sm-12 login-wrapper-container">
						<form action="" className="form-horizontal step-login-form" method="">
							<div className="col-lg-offset-4 col-md-offset-4 col-lg-4 col-md-4 col-sm-12 login-box">
								<div className="message_box">
									<div className={panelClass}>{panelMsg}</div>
								</div>
								<div className="login-theader">
									<img
										width="150"
										src="https://assets.lntedutech.com/edutech_logo.svg"
										alt="L&T logo"
									/>
								</div>
								<p>You are being redirected to the L&T Assessment Portal.</p>
								<div>
									<img
										src={Config.ASSETSPATH + 'img/ajaxSpinner.gif'}
										alt="Step Loader"
										width="18%"
									/>
								</div>
							</div>
						</form>
					</div>
				</div>
			)}
		</div>
	);
};

const mapStateToProps = (state) => {
	const {
		success,
		token,
		sso,
		returnPath,
		returnSearch,
		referer,
	} = state.rootReducer.ssoDetails;
	const { errorPanel } = state.rootReducer.utils;
	return {
		errorPanel,
		success,
		token,
		sso,
		returnPath,
		returnSearch,
		referer,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		validateUser: () => dispatch(validateUser()),
		setPayMethod: (val) => dispatch(setPayMethod(val)),

		setEnableProctor: (val) => dispatch(setEnableProctor(val)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Sso);
